import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { Subscription } from "rxjs";
import { MessageService } from "src/app/services/message.service";
import { ProfileService } from "src/app/services/profile.service";
import { UsersService } from "src/app/services/users.service";
import { CATEGORY_SELECT_STYLE, OWNER_ID, USER_TYPE } from "../../../constants";
import { IOrganization } from "../../../dtos";

@Component({
	selector: "app-users-list",
	templateUrl: "./users-list.component.html",
	styleUrls: ["./users-list.component.scss"],
})
export class UsersListComponent implements OnInit {
	@Output()
	primaryContactEvent: EventEmitter<any> = new EventEmitter();
	primaryContact = "";
	users;

	private subscriptions: Subscription[] = [];
	dropDownStyle = CATEGORY_SELECT_STYLE;

	constructor(
		public usersService: UsersService,
		private profileService: ProfileService,
		private messageService: MessageService
	) {}

	ngOnInit() {
		this.messageService.getMessage().subscribe((response) => {
			if (response && response.organizationDetails) {
				const primaryContact =
					response.organizationDetails.primaryContact;
				const type = response.organizationDetails.type;
				if (type === USER_TYPE.BUYER) {
					this.loadPrimaryContact(
						primaryContact,
						response.organizationDetails.buyers,
						type
					);
				} else if (type === USER_TYPE.SUPPLIER) {
					this.loadPrimaryContact(
						primaryContact,
						response.organizationDetails.suppliers,
						type
					);
				}
			}
		});

		let sb = this.profileService.lastSelectedOrganization$.subscribe(
			(org: IOrganization) => {
				const primaryContact = org.primaryContact;
				const type = org.type;
				if (type === USER_TYPE.BUYER) {
					this.loadPrimaryContact(primaryContact, org.buyers, type);
				} else if (type === USER_TYPE.SUPPLIER) {
					this.loadPrimaryContact(
						primaryContact,
						org.suppliers,
						type
					);
				}
			},
			(err) => {
				if (err) {
					this.profileService.loadProfile();
				}
			}
		);
		this.subscriptions.push(sb);
	}

	ngOnDestroy(): void {
		this.subscriptions.forEach((sb) => sb.unsubscribe());
	}

	selectPrimaryContact(value) {
		this.primaryContact = value;
		this.primaryContactEvent.emit(this.primaryContact);
	}

	loadPrimaryContact(primaryContact, users: [], type: string) {
		let ownerId =
			type === USER_TYPE.BUYER ? OWNER_ID.BUYER : OWNER_ID.SUPPLIER;
		this.users = users.map((user) => {
			let userId = user["id"];
			let email = user["email"];
			let roleId =
				type === USER_TYPE.BUYER
					? user["OrganizationBuyers"] &&
					  user["OrganizationBuyers"]["roleId"]
					: user["OrganizationSuppliers"] &&
					  user["OrganizationSuppliers"]["roleId"];
			if (!primaryContact && roleId === ownerId) {
				this.primaryContact = userId;
			} else if (primaryContact && userId === primaryContact) {
				this.primaryContact = userId;
			}
			return {
				email: email,
				id: userId,
			};
		});
	}
}
